import { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

// Lazy load toast components
const Toaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));
const Sonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));
const Privacy = lazy(() => import("./pages/Privacy"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const AdminPostEditor = lazy(() => import("./pages/AdminPostEditor"));
const HabitTrackerWithoutStreaks = lazy(() => import("./pages/HabitTrackerWithoutStreaks"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Suspense fallback={null}>
          <Toaster />
          <Sonner />
        </Suspense>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/privacy" element={
              <Suspense fallback={<div className="min-h-screen bg-cream" />}>
                <Privacy />
              </Suspense>
            } />
            <Route path="/blog" element={
              <Suspense fallback={<div className="min-h-screen bg-cream" />}>
                <Blog />
              </Suspense>
            } />
            <Route path="/blog/:slug" element={
              <Suspense fallback={<div className="min-h-screen bg-cream" />}>
                <BlogPost />
              </Suspense>
            } />
            <Route path="/admin/login" element={
              <Suspense fallback={<div className="min-h-screen bg-cream" />}>
                <AdminLogin />
              </Suspense>
            } />
            <Route path="/admin" element={
              <Suspense fallback={<div className="min-h-screen bg-cream" />}>
                <AdminDashboard />
              </Suspense>
            } />
            <Route path="/admin/posts/:id" element={
              <Suspense fallback={<div className="min-h-screen bg-cream" />}>
                <AdminPostEditor />
              </Suspense>
            } />
            <Route path="/habit-tracker-without-streaks" element={
              <Suspense fallback={<div className="min-h-screen" style={{ backgroundColor: "#FDFBF7" }} />}>
                <HabitTrackerWithoutStreaks />
              </Suspense>
            } />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
